import React from "react";
import * as c from "./blogAd.module.scss";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { CtaVideoButton } from "@components/shared/cta";
import classNames from "classnames";
import { processMarkdown } from "@utils/markdown";
import WistiaVideoPopover from "@components/wistia/wistiaVideoPopover";
import IconPlay from "@icons/iconPlay";

// TODO: Should have an interface for handling these same content-types
// and then override styling in the component instead. Will be used a
// lot...
// For now we make some assumptions about the values we get from
// Contentful e.g. only one type of CTA, same order image column,
// no mobile image etc. Need to clean this up.
//
const BlogAd = ({
  className,
  label,
  heading,
  subheading,
  shouldShowImageColumnFirst,
  wistiaVideoId = null,
  desktopImage,
  mobileImage,
  ctas = [],
}) => {
  const subheadingHtml = processMarkdown(subheading?.subheading);
  const ctaLabel = ctas && ctas.length > 0 ? ctas[0].label : "Watch now";

  return (
    <>
      <div className={classNames(c.container, className)}>
        <div className={c.imageContainer}>
          <div className={c.wistiaWrapper}>
            <WistiaVideoPopover className={c.wistia} wistiaVideoId={wistiaVideoId}>
              <IconPlay className={c.playButton} />
            </WistiaVideoPopover>
          </div>
          <GatsbyImage
            className={c.image}
            objectFit="cover"
            objectPosition="center center"
            image={getImage(desktopImage)}
            alt={heading}
          />
        </div>
        <div className={c.text}>
          <p className={c.eyebrow}>{label}</p>
          <h3 className={c.heading}>{heading}</h3>
          <p className={c.subheading} dangerouslySetInnerHTML={{ __html: subheadingHtml }} />
          <CtaVideoButton className={c.cta} label={ctaLabel} wistiaVideoId={wistiaVideoId} />
        </div>
      </div>
    </>
  );
};

export { BlogAd };
